import React from "react";
import { parseRemediationTrigger } from "../utils/remediationTrigger";

// Renders the dbAxionRemediationTrigger free-text field as a numbered list when it uses a
// recognizable marker style ("(1) ...", "(a) ..."), otherwise as plain text. Shared by every
// risk-list page (AllRisks, VendorDashboard, and the 7 per-type assessment risk views) so the
// parsing/formatting only lives in one place — see utils/remediationTrigger.js.
export default function RemediationTriggerList({ trigger }) {
  if (!trigger) return null;

  const { intro, items } = parseRemediationTrigger(trigger);

  if (!items) {
    return <p className="text-sm text-gray-700 break-words">{trigger}</p>;
  }

  return (
    <>
      {intro && <p className="text-sm text-gray-700 mb-2">{intro}</p>}
      <ol className="space-y-1 list-decimal list-inside">
        {items.map((item, i) => (
          <li key={i} className="text-sm text-gray-700">
            {item}
          </li>
        ))}
      </ol>
    </>
  );
}
